/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { AppRouter, getInheritedRouteParam, getRouteParam, getRoutePath } from '@gh/common-shared';
import { SupplierUserContext } from '@gh/supplier-shared';
import { first } from 'lodash';

@Injectable()
export class SupplierOfficeActivator implements CanActivate {
  constructor(private userContext: SupplierUserContext,
              private router: AppRouter) {
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    // if user context is not initialized (in case of error on login) => forbid to open any page
    if (!this.userContext.isInitialized()) {
      return false;
    } else if (getRoutePath(route) === '') {
      // if root url => navigate to the first office
      if (this.userContext.offices.length === 1) {
        this.router.navigateByUrl(`/offices/${this.userContext.currentOffice.id}/purchase-orders`);
        return false;
      } else if (this.userContext.offices.length > 1) {
        this.router.navigateByUrl(`/offices/all/purchase-orders`);
        return false;
      } else {
        return true;
      }
    } else if (route.data.isAcceptInvitation) {
      // if acceptInvitation => navigate to the accepted office
      const officeId = getRouteParam(route, 'officeId');
      if (this.userContext.isOfficeExist(officeId)) {
        this.router.navigateByUrl(`/offices/${officeId}/purchase-orders`);
      } else if (this.userContext.offices.length === 1) {
        this.router.navigateByUrl(`/offices/${this.userContext.currentOffice.id}/purchase-orders`);
      } else if (this.userContext.offices.length > 1) {
        this.router.navigateByUrl(`/offices/all/purchase-orders`);
      } else {
        this.router.navigateByUrl('');
      }
      return false;
    } else {
      const officeId = getInheritedRouteParam(route, 'officeId');
      if (officeId) {
        if (officeId === 'all') {
          // tslint:disable-next-line:no-non-null-assertion
          this.userContext.setCurrentOffice(first(this.userContext.offices)!.id);
          return true;
        } else if (this.userContext.isOfficeExist(officeId)) {
          this.userContext.setCurrentOffice(officeId);
          return true;
        } else {
          this.router.navigateByUrl('/404');
          return false;
        }
      } else {
        return true;
      }
    }
  }

}
